import { NuxtLink } from '#components'

/** 数据转换函数 */
export const convertData = (data: any[]): any[] => {
  return data.map((item: any) => {
    const children = item.son && item.son.length > 0 ? convertData(item.son) : null
    const label = () => {
      if (item.url) {
        return (
          <div class="header-color" style="color: var(--color-headerColor)">
            <NuxtLink target={item.target} href={item.url}>
              {item.name}
            </NuxtLink>
          </div>
        )
      }
      return (
        <div class="header-color">
          {item.name}
        </div>
      )
    }
    return {
      label,
      key: `${item?.id}-${Math.random()}-${Date.now()}`,
      ...(children && { children }),
    }
  })
}
